import { render } from "./tasks.vue?vue&type=template&id=1ac37157&scoped=true"
import script from "./tasks.vue?vue&type=script&lang=js"
export * from "./tasks.vue?vue&type=script&lang=js"

import "./tasks.vue?vue&type=style&index=0&id=1ac37157&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac37157"]])

export default __exports__